import * as React from "react";
import { useCartStorage } from "@grandvisionhq/lib-utils-cart";
import { ApplePayExpressCheckoutButtonContainer, GooglePayExpressCheckoutButtonContainer, PaypalExpressButton } from "@grandvisionhq/payments";
/* empty css                            */
const ExpressActionContainer = ({
  hasSubscription,
  isOrderInProgress,
  setIsOrderInProgress,
  onClickHandler
}) => {
  const [{ cartId, cartHash }] = useCartStorage();
  if (!cartId) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", { className: "express-action__payment-methods" }, /* @__PURE__ */ React.createElement(
    ApplePayExpressCheckoutButtonContainer,
    {
      cartId,
      cartHash,
      onClickHandler
    }
  ), /* @__PURE__ */ React.createElement(
    GooglePayExpressCheckoutButtonContainer,
    {
      cartId,
      cartHash,
      onClickHandler
    }
  ), !hasSubscription && cartHash && /* @__PURE__ */ React.createElement(
    PaypalExpressButton,
    {
      setIsOrderInProgress,
      cartId,
      cartHash,
      isOrderInProgress,
      onClickHandler
    }
  ));
};
export {
  ExpressActionContainer
};
//# sourceMappingURL=ExpressActionContainer.js.map
